import competition from '@/store/modules/competition/competition'
import competitionCreate from '@/store/modules/competition/competition-create'
import competitionEdit from '@/store/modules/competition/competition-edit'
import competitionDelete from '@/store/modules/competition/competition-delete'
import competitionList from '@/store/modules/competition/competition-list'
import competitionCalendar from '@/store/modules/competition/competition-calendar'
import competitionCalendarPlan from '@/store/modules/competition/competition-calendar-plan'
import competitionCalendarPlanCreate from '@/store/modules/competition/competition-create-plan'
import competitionCalendarPlanEdit from '@/store/modules/competition/competition-calendar-plan-edit'
import competitionCalendarPlanDelete from '@/store/modules/competition/competition-calendar-plan-delete'
import competitionCalendarPlanFilter from '@/store/modules/competition/competition-calendar-plan-filter'

export default {
  competition,
  competitionCreate,
  competitionEdit,
  competitionDelete,
  competitionList,
  competitionCalendar,
  competitionCalendarPlan,
  competitionCalendarPlanCreate,
  competitionCalendarPlanEdit,
  competitionCalendarPlanDelete,
  competitionCalendarPlanFilter,
}
